import theme from './bioBridge'

export default () => `
  body {
    margin: 0;
  }
  .ant-table-thead th.ant-table-cell {
    color: ${theme.brandPrimaryOnLight} !important;
    font-weight: 500 !important;
  }
  /* antd's preset tag colours are step 6 of each hue on its own step-1 tint,
     which lands between 2.8:1 and 3.7:1 at 12px. Step 8 (step 9 for gold)
     clears AA on the same tints. !important because antd's own rule carries the
     emotion-hashed class alongside .ant-tag-*, so it outranks a bare selector. */
  .ant-tag-green,
  .ant-tag-success {
    color: #237804 !important;
  }
  .ant-tag-cyan {
    color: #006d75 !important;
  }
  .ant-tag-blue,
  .ant-tag-processing {
    color: #0958d9 !important;
  }
  .ant-tag-orange {
    color: #ad4e00 !important;
  }
  .ant-tag-gold,
  .ant-tag-warning {
    color: #874d00 !important;
  }
  .ant-tag-volcano {
    color: #ad2102 !important;
  }
  /* antd's "No data" caption is 3.36:1 on white. */
  .ant-empty-description {
    color: #595959 !important;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  .ant-typography[class*="title"],
  .primary-text,
  .ant-divider-inner-text {
    color: ${theme.brandPrimary};
  }

  .ant-form-item label {
    overflow: visible;
    white-space: normal;
    vertical-align: top;
  }

  .form-items-wrapper ant-form-item-additional {
    min-height: 0 !important;
  }

  .form-items-wrapper .ant-form-item {
    margin-bottom: 0 !important;
  }
`
